import React, { useEffect, useState } from 'react';
import { WechatFilled, LaptopOutlined, WechatWorkOutlined, PhoneFilled } from '@ant-design/icons';
import {
  Card, List, Tooltip, Typography, Space, Popover,
  Image,
  FloatButton, QRCode, Input, Col, Row, Tabs, Modal
} from 'antd';
import './index.scss';
import Apwjreg from './_reg'
import Apwjlogin from './_login'
import Hnreg from './_hnreg';
import Hnlogin from './_hnlogin';


const { TextArea } = Input;

const { Text } = Typography;


const Fbody = () => {


  const [modal2Open, setModal2Open] = useState(false);
  const [modalhn2Open, setModalhn2Open] = useState(false);

  const [text, setText] = useState('http://www.ddspp.com/');
  useEffect(() => { }, [text])

  // const data = [
  //   {
  //     title: <><SoundFilled />  印刷喷码注意事项</>, content: <div className='con_sone'>辛苦绝对是，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克</div>
  //   },
  //   {
  //     title: <><SoundFilled /> 印刷喷码注意事项</>, content: <div className='con_sone'>辛苦绝对是，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克</div>
  //   },
  //   {
  //     title: <><SoundFilled /> 印刷喷码注意事项</>, content: <div className='con_sone'>辛苦绝对是，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克，萨卡手机卡刷卡机萨克</div>
  //   },
  // ];

  const data2 = [

    {
      title: <Tooltip title="农药化肥种子 生产运营优惠版" placement="bottomLeft" color="blue"><div className='titlecs' onClick={() => setModalhn2Open(true)} >普惠版</div></Tooltip>,
      extra: <LaptopOutlined style={{ fontSize: '2em', color: '#4096ff', }} onClick={() => setModalhn2Open(true)} />
      ,
      content: <div className='con_one'>
        <Space orientation="vertical" size="small">
          <Text>适用农药、化肥、种子生产经营者使用的平台系统。</Text>
          <Text>数据量不设限，单批次下载可超百万；保存更久，企业自主删除。</Text>
          <Text>支持营销活动，奖池灵活，按需充值，不压资金。支持验证互动，私域引流(关注公众号、私域电商成交等)。</Text>
        </Space>


      </div>
    },
    {
      title: <Tooltip title="通用版" placement="bottomLeft" color="blue"><div className='titlecs'>无界版</div></Tooltip>,
      extra: <Tooltip title="登录" placement="bottom" color="blue"><LaptopOutlined style={{ fontSize: '2em', color: '#4096ff', }} onClick={() => setModal2Open(true)} /></Tooltip>,
      content: <div className='con_one'>
        <Space orientation="vertical">
          <Text>适用于无特殊要求的一般类商品。</Text>
          <Text>功能模块化，按需选购。商品全生命周期追溯，多场景、多主体信息互动。</Text>
          <Text>支持可信数据链(可信区块链技术)，去中心化、透明公开算法，是打造口碑得力助手。</Text>

        </Space>

      </div>
    },
  ];

  const mtpl = { 'margin': "0px 0px 10px", }

  return <>


    <div
      className='fbodym'
    >



      <div className='btfontcss'>二维码防伪追溯的本质是产品运营数字化,数字化的基础是一物一码.</div>


      <Card
        style={mtpl}
      >  <Row>
          <Col span={4}
            className='nrcenter'
          >
            <QRCode value={text ||
              'http://www.ddspp.com'}
            />
          </Col>
          <Col span={20} >
            <TextArea
              rows={7}
              placeholder="http://www.ddspp.com"
              maxLength={80}

              value={text}
              onChange={(e) => { setText(e.target.value) }
              }
              showCount
            />
          </Col>
        </Row></Card>


      <List
        grid={{
          gutter: 16,
          column: 2,
        }}
        split={false}
        dataSource={data2}
        renderItem={(item) => (
          <List.Item>
            <Card title={item.title} extra={item.extra}>{item.content}</Card>
          </List.Item>
        )}
      />



   




      <Modal
        name='无界'
        closable={false}
        centered
        footer={null}
        open={modal2Open}
        onCancel={() => setModal2Open(false)}

      >
        <Tabs
          defaultActiveKey="1"
          centered

          items={[{ label: '登录', key: 'm01', children: <Apwjlogin />, },
          { label: '注册', key: 'm02', children: <Apwjreg />, }]}
        />
      </Modal>




      <Modal
        name='普惠'
        closable={false}
        centered
        footer={null}
        open={modalhn2Open}
        onCancel={() => setModalhn2Open(false)}

      >
        <Tabs
          defaultActiveKey="hn1"
          centered

          items={[{ label: '登录', key: 'hn01', children: <Hnlogin />, },
          { label: '注册', key: 'hn02', children: <Hnreg />, }]}
        />
      </Modal>
    </div>



    <FloatButton.Group
      shape="square"
      style={{
        insetInlineEnd: 94,
      }}
    >
      <FloatButton icon={<WechatWorkOutlined style={{
        color: '#389e0d',
      }} />}

        href="https://work.weixin.qq.com/kfid/kfcfeff9d9a4dfb1ce0"
        target="_blank"
        className='wxkf'
      />

      <Popover placement="left" content={<Image
        width={80}
        src="https://shengcong.sh3.ikuai7.com/ap_res/v3/1000_1765643012#sc"
        preview={false}
      />}><FloatButton icon={<WechatFilled style={{
        color: '#389e0d',
      }} />} /></Popover>
      <Popover placement="left" content='400-6231-315' ><FloatButton icon={<PhoneFilled style={{
        color: '#389e0d',
      }} />} /></Popover>

    </FloatButton.Group>


  </>


}

export default Fbody